module.exports = __webpack_public_path__ + "img/dog.5aa902e7.jpg";